module.exports = __webpack_public_path__ + "img/postback-step-7.en.cb586b5c.jpg";